/* eslint-disable no-constant-condition */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* skeleton for dashboard */
import React from 'react';
import { Skeleton } from 'react-skeleton-generator';
import HeaderSkeleton from './HeaderSkeleton';

function DistributoSkeleton() {
    return (
        <Skeleton.SkeletonThemeProvider highlight="#C0C0C0">
            <HeaderSkeleton Skeleton={Skeleton} />
            <div className="bg-[#F5F5FA] rounded-[7px] w-fit mt-[27px] pt-4 pl-4 pr-4 pb-3 flex">
                <div>
                    <span className="text-xs9 font-normal text-[#555259] mb-2"><Skeleton width="50px" /></span>
                    <p className="text-xs4 font-normal text-[#090406] pt-2.5"><Skeleton width="50px" /></p>
                </div>
                <div className="ml-[83px]">
                    <div className="flex">
                        <p className="text-xs9 font-normal text-[#555259]"><Skeleton width="120px" height="15px" /></p>
                        <button type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                            <img src="/images/edit-2.svg" alt="icon" className="pl-2.5" />
                        </button>
                    </div>
                    <ul className="pt-2.5 flex mt-1">
                        <li className="text-xs6 font-normal text-[#090406] bg-[#FFFFFF] px-2.5 py-1.5 w-fit cursor-pointer rounded-[7px] "><Skeleton width="70px" height="20px" /></li>
                        <li className="text-xs6 font-normal text-[#090406] bg-[#FFFFFF] px-2.5 py-1.5 w-fit cursor-pointer rounded-[7px] ml-2"><Skeleton width="90px" height="20px" /></li>
                    </ul>
                </div>
            </div>
            <div className="mt-10 flex">

                {[...Array(3)].map((val) => (
                    <div className="rounded-lg border border-[#EBEBEB] bg-[#FFFFFF] shadow-s6 pl-[15px] pt-[15px] pr-6 pb-2.5 w-1/3" key={val}>
                        <p className="text-xs6 font-normal text-[#090406] mb-1"><Skeleton width="120px" height="18px" /></p>
                        <p className="text-lg font-semibold text-[#090406] flex justify-end"><Skeleton width="90px" height="18px" /></p>
                    </div>
                ))}
            </div>
            {true && (
                <div className="flex mt-2">
                    <div className="mt-10 px-10 pt-[26px] bg-[#F5F5FA] rounded-[7px] w-[70%]">
                        <ul className="nav nav-pills flex border-b border-[#FFFFFF]" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <a
                                    href="javascript:void(0)"
                                    className="nav-link block text-xs10 font-normal text-[#555259] regadd pb-3.5 relative"
                                    id="pills-regAddress-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-regAddress"
                                    role="tab"
                                    aria-controls="pills-regAddress"
                                    aria-selected="true"
                                >
                                    <Skeleton width="180px" height="35px" />
                                </a>
                            </li>
                            <li className="nav-item pl-[130px]" role="presentation">
                                <a
                                    href="javascript:void(0)"
                                    className="nav-link block text-xs10 font-normal text-[#555259] regadd pb-3.5 relative"
                                    id="pills-ador-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-ador"
                                    role="tab"
                                    aria-controls="pills-ador"
                                    aria-selected="true"
                                >
                                    <Skeleton width="180px" height="35px" />
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show pt-[30px] pb-[140px]" id="pills-regAddress" role="tabpanel" aria-labelledby="pills-regAddress-tab">
                                <div className="flex">
                                    <div className="w-1/2 pr-[30px]">
                                        <p className="text-lg font-normal text-[#555259]">
                                            <Skeleton height="15px" width="150px" />

                                        </p>

                                        {[...Array(4)].map((value) => (
                                            <div className="rounded-[7px] bg-[#FFFFFF] px-7 pt-3 pb-3.5 mt-5" key={value}>
                                                <p className="text-xs6 font-normal text-[#808285]"><Skeleton height="10px" width="70px" /></p>
                                                <p className="pt-4 text-xs6 font-normal text-[#090406]">
                                                    <Skeleton height="10px" width="200px" />
                                                    <Skeleton height="10px" width="150px" />
                                                    <Skeleton height="10px" width="100px" />
                                                    <Skeleton height="10px" width="100px" />
                                                </p>

                                            </div>
                                        ))}

                                    </div>
                                    <div className="w-1/2">
                                        <div>
                                            <p className="text-lg font-normal text-[#555259]">
                                                {' '}
                                                <Skeleton height="15px" width="150px" />
                                            </p>
                                            {[...Array(2)].map((item) => (
                                                <div className="rounded-[7px] bg-[#FFFFFF] px-7 pt-3 pb-3.5 mt-5" key={item}>
                                                    <div className="flex justify-between">
                                                        <p className="text-xs6 font-normal text-[#808285]"><Skeleton height="10px" width="70px" /></p>
                                                        <div>
                                                            <p className="text-xs3 font-normal text-[#808285]"><Skeleton height="13px" width="70px" /></p>
                                                            <div
                                                                className="dropdown relative"
                                                            >
                                                                <button type="button" id="dropdownMenucity" data-bs-toggle="dropdown" aria-expanded="false" className="customrotate">
                                                                    <span className="text-xs6 font-bold text-[#090406] flex">
                                                                        <Skeleton height="9px" width="50px" />
                                                                        {/* <img src="/images/chevron-Up.svg" alt="icon" className="ml-1.5 default-dropdown transition-all duration-500" /> */}
                                                                    </span>
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <p className="pt-4 text-xs6 font-normal text-[#090406]">
                                                        <Skeleton height="10px" width="200px" />
                                                        <Skeleton height="10px" width="150px" />
                                                        <Skeleton height="10px" width="100px" />
                                                        <Skeleton height="10px" width="100px" />
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-10 ml-2.5 w-[30%] pt-5 px-3 pb-[30px] bg-[#F5F5FA] rounded-[7px]">
                        <div className="flex justify-between">
                            <div className="flex items-center">
                                <p className="text-xs11 font-semibold text-[#090406]">Privileges</p>
                                <img src="/images/edit-2.svg" alt="icon" className="pl-3.5 cursor-pointer privillages" />
                            </div>
                            <button type="button" className={`h-[36px] w-[76px] text-center py-2 rounded bg-[#555259] text-base font-normal text-[#FFFFFF] save ${false ? '' : 'hidden'}`}>
                                Save
                            </button>
                        </div>
                        {[...Array(12)].map((item, i) => (
                            <div className="mt-[25px] px-[18px] py-3 bg-[#FFFFFF] rounded-[7px]" key={i}>
                                <Skeleton width="150px" height="20px" />
                            </div>

                        ))}
                    </div>
                </div>
            )}
        </Skeleton.SkeletonThemeProvider>
    );
}

export default DistributoSkeleton;
